import { render, staticRenderFns } from "./Rights_Grouping.vue?vue&type=template&id=09beea1d&"
import script from "./Rights_Grouping.vue?vue&type=script&lang=js&"
export * from "./Rights_Grouping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports